import React from 'react'
import {Icon} from '@chakra-ui/react'
const GoBackIcon = (props) => {
    return (
        <Icon viewBox="0 0 24 24" fill="none" {...props}>
            <path
                d="M14.505 7.9925H6.415L9.705 4.7025C10.095 4.3125 10.095 3.6825 9.705 3.2925C9.315 2.9025 8.685 2.9025 8.295 3.2925L3.295 8.2825C3.205 8.3725 3.125 8.4825 3.075 8.6125C2.975 8.8525 2.975 9.1325 3.075 9.3725C3.125 9.4925 3.195 9.6025 3.295 9.7025L8.295 14.7025C8.495 14.9025 8.745 14.9925 9.005 14.9925C9.265 14.9925 9.515 14.8925 9.715 14.7025C10.105 14.3125 10.105 13.6825 9.715 13.2925L6.425 10.0025H14.515C16.995 10.0025 19.015 12.0225 19.015 14.5025C19.015 16.9825 16.995 19.0025 14.515 19.0025H11.015C10.465 19.0025 10.015 19.4525 10.015 20.0025C10.015 20.5525 10.465 21.0025 11.015 21.0025H14.515C18.095 21.0025 21.015 18.0825 21.015 14.5025C21.015 10.9225 18.095 8.0025 14.515 8.0025L14.505 7.9925Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default GoBackIcon
